<template>
  <div style="background: #f9f9f9; height: calc(100vh - 44px)">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack">
        <img src="@/assets/img/appointment/back.svg" />
      </div>
      <div class="nav-title d-allcenter overflow">邀请伙伴</div>
      <div class="nav-right d-allcenter" style="font-size: 12px">刷新</div>
    </div>
    <div class="content d-aligncnter d-column d-allcenter">
      <div class="info-box d-allcenter" @click="pageToAdd">
        <img src="@/assets/img/appointment/add-plus-grey.svg" style="margin-right: 8px" />添加新伙伴
      </div>
      <div class="grey" style="width: calc(100% - 32px)">操作说明：伙伴必须在其账号里录入人脸信息才能被邀请。</div>
      <div class="info-box" v-if="friendList.length > 0">
        <div style="padding: 0 16px">
          <el-checkbox-group v-model="checkList" @change="friendsChange">
            <el-checkbox
              :label="item.id"
              class="d-aligncnter mycheck"
              :disabled="!item.face"
              v-for="(item, index) in friendList"
              :key="'friend_' + index"
            >
              <div class="d-between d-aligncnter" style="width: calc(100vw - 124px)">
                <div class="d-column">
                  <div>{{ item.name }}</div>
                  <div class="grey">{{ item.mobile }}</div>
                </div>
                <div
                  class="fs-xs"
                  style="color: #fff; background: #e14c46; padding: 2px 4px; border-radius: 90px"
                  v-if="!item.face"
                >
                  缺少人脸数据
                </div>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <!-- <div class="d-allcenter" style="position: fixed; bottom: 32px; width: 100vw"> -->
    <div class="d-allcenter" v-if="friendList.length > 0">
      <button class="save-btn" style="width: 136px" @click="pageToBack">
        <div>确认</div>
        <div>{{ checkList.length }}/{{ friendList.length }}</div>
      </button>
    </div>
  </div>
</template>
<script>
// import { Message } from 'element-ui'
import { getPartnerList } from '@/api/api-venueOrder'

export default {
  data() {
    return {
      phone: '',
      userInfo: { headImg: '', name: '', mobile: '' },
      rightText: '编辑',
      radio: 0,
      checkList: [],
      friendList: [
        // { name: '张三', phone: '152****8888', id: 1, hasFace: true },
        // { name: '李四', phone: '152****8888', id: 2, hasFace: true },
        // { name: '王五', phone: '152****8888', id: 3, hasFace: true },
        // { name: '赵六', phone: '152****8888', id: 4, hasFace: false },
      ],
    }
  },
  mounted() {
    this.getMyFriends()
  },
  methods: {
    pageToBack() {
      let data = []
      for (let i = 0; i < this.checkList.length; i++) {
        for (let j = 0; j < this.friendList.length; j++) {
          if (this.checkList[i] == this.friendList[j].id) {
            data.push(this.friendList[j])
          }
        }
      }
      console.log(data)
      localStorage.setItem('friendlist', JSON.stringify(data))
      this.$router.go(-1)
    },
    friendsChange() {
      console.log(this.checkList)
    },
    pageToAdd() {
      this.$router.push('/appointment/addfriend')
    },
    getMyFriends() {
      const userId = localStorage.getItem('userId')
      getPartnerList(userId)
        .then((res) => {
          console.log(res)
          if (res.data.statusCode == 1) {
            this.friendList = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}
.content {
  padding: 0;
  background: #f9f9f9;
}
.each {
  background: #f9f9f9;
  box-shadow: 0px -1px 0px 0px #e8e8e8 inset;
  padding: 8px 16px;
  min-height: 32px;
  color: #181818;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4a3fc;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.save-btn {
  border-radius: 52px;
  //   background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  background: #339571;
  width: 343px;
  height: 42px;
  border: 1px solid #339571;
  color: #fff;
  font-size: 14px;
  margin-top: 16px;
  //   position: absolute;
  //   bottom: 152px;
}
.ml-16 {
  margin-left: 16px;
}
.order-info {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  //   padding: 16px;
  margin: 16px;
  width: calc(100% - 64px);
}
.info-box {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  width: calc(100% - 64px);
  padding: 16px 0;
  margin: 16px;
}

.info-box ::v-deep .el-checkbox__inner::after {
  height: 10px;
  left: 7px;
  top: 3px;
}
.info-box ::v-deep .el-checkbox__inner {
  width: 20px;
  height: 20px;
}
.info-box ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #339571;
  border-color: #339571;
}
.info-box ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #339571;
}
.info-box ::v-deep .el-checkbox__inner:hover {
  border-color: #339571 !important;
}
.info-box ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #339571 !important;
}
.mycheck {
  margin: 6px 0;
}
</style>
